import { Feedback } from '../models';
import { Network } from '../utils';

export const addFeedback = async (feedback: Feedback) => Network.post('feedback', feedback);
